<template lang="html">

  <div class="contenedor-tarifas">
    <article class="tarifa-el" id="tranquilidad"
      v-if="getTarifasLuz('tranquilidad') && (tarifaActiva == 'tranquilidad' || tarifaActiva == null)">


      <div class="nombre-tarifa container">
        <figure>1</figure>
        <h2>
          <span class="-purple">{{ $t('tarifasLuz.tarifas.hogar.estandar["tranquilidad"].title') }}</span>
          <span class="-orange">{{ $t('tarifasLuz.tarifas.hogar.estandar["tranquilidad"].subtitle') }}</span>
        </h2>
      </div>

      <div class="contenedor-intro-tarifa row-center">
        <div class="textos container">
          <div class="contenedor-textos">
            <h3 class="-orange">{{ $t('tarifasLuz.tarifas.hogar.estandar["tranquilidad"].claim') }}</h3>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.estandar["tranquilidad"].objetive1') }}</h5>
          </div>
        </div>

        <img src="/static/img/background-luz-estandar-3.webp" class="img-tarifa">

        <img src="/static/img/figuras-moradas.svg" class="figuras-naranjas">

      </div>

      <div class="contenedor-boton" v-show="!showpreciosDA">

        <a @click="showpreciosDA = true" class="btn -degree">{{ $t('quieroEstaTarifa') }}</a>

      </div>

      <seleccion-precio-tarifa :how="'DA'" :type="'tranquilidad'" :priceType="'fixed'"></seleccion-precio-tarifa>


    </article>

    <article class="tarifa-el" id="clasica"
        v-if="getTarifasLuz('clasica') && (tarifaActiva == 'clasica' || tarifaActiva == null)">
 
      <div class="nombre-tarifa container">
        <figure>2</figure>
        <h2>
          <span class="-purple">{{ $t('tarifasLuz.tarifas.hogar.estandar["clasica"].title') }}</span>
          <span class="-orange">{{ $t('tarifasLuz.tarifas.hogar.estandar["clasica"].subtitle') }}</span>
        </h2>
      </div>

      <div class="contenedor-intro-tarifa row-center inside-picture">
        <div class="textos container">
          <div class="contenedor-textos">
            <h3 class="-orange">{{ $t('tarifasLuz.tarifas.hogar.estandar["clasica"].claim') }}</h3>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.estandar["clasica"].objetive1') }}</h5>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.estandar["clasica"].objetive2') }}</h5>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.estandar["clasica"].objetive3') }}</h5>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.estandar["clasica"].objetive4') }}</h5>
          </div>
        </div>

        <img src="/static/img/background-luz-estandar-1.webp" class="img-tarifa">

        <img src="/static/img/figuras-naranjas.svg" class="figuras-naranjas">

      </div>

      <div class="contenedor-boton" v-show="!showpreciosDHA">

        <a @click="showpreciosDHA = true" class="btn -degree">{{ $t('quieroEstaTarifa') }}</a>

      </div>

      <seleccion-precio-tarifa :how="'DHA'" :type="'clasica'" :priceType="'fixed'"></seleccion-precio-tarifa>

    </article>

    <article class="tarifa-el" id="precioCoste" v-if="getTarifasLuz('clasica') && (tarifaActiva == 'precioCoste' || tarifaActiva == null)">

      <div class="nombre-tarifa container">
        <figure>3</figure>
        <h2>
          <span class="-purple">{{ $t('tarifasLuz.tarifas.hogar.estandar["precioCoste"].title') }}</span>
          <span class="-orange">{{ $t('tarifasLuz.tarifas.hogar.estandar["precioCoste"].subtitle') }}</span>
        </h2>
      </div>

      <div class="contenedor-intro-tarifa row-center">
        <div class="textos container">
          <div class="contenedor-textos">
            <h3 class="-orange">{{ $t('tarifasLuz.tarifas.hogar.estandar["precioCoste"].claim') }}</h3>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.estandar["precioCoste"].objetive1') }}</h5>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.estandar["precioCoste"].objetive2') }}</h5>
          </div>
        </div>

        <img src="/static/img/background-luz-estandar-2.webp" class="img-tarifa">

        <img src="/static/img/figuras-moradas.svg" class="figuras-naranjas">

      </div>

      <div class="contenedor-boton" v-show="!showpreciosDA">

        <a @click="showpreciosDA = true" class="btn -degree">{{ $t('quieroEstaTarifa') }}</a>

      </div>

      <seleccion-precio-tarifa :how="'DA'" :type="'precioCoste'" :priceType="'index'"></seleccion-precio-tarifa>
    </article>

  </div>

</template>

<script lang="js">

import seleccionPrecioTarifa from '@/components/parts/selector-precio-tarifa';

import { mapGetters } from 'vuex';

export default {
  name: 'tarifas-menos',
  props: ['tarifaActiva'],
  data() {
    return {
      showpreciosDA: true,
      showpreciosDHA: true,
    }
  },
  components: {
    'seleccion-precio-tarifa': seleccionPrecioTarifa
  },
  computed: {
    ...mapGetters({
      horario: 'gethorario',
      precios: 'getPrecios',
    })
  },
  watch: {
    tarifaActiva(newTarifa) {
      if (!newTarifa) return;

      this.$nextTick(() => {
        const section = document.getElementById('botonera-tarifas');
        if (section) {
          const header = document.querySelector('.header');
          const headerHeight = header ? header.offsetHeight : 0;
          const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: Math.max(sectionTop - headerHeight, 0),
            behavior: 'smooth'
          });
        }
      });
    }
  },
  methods: {
    getTarifasLuz(type) {
      if (!!this.precios) {
        return this.precios.tarifas_luz[type];
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/luz/tarifas-estandar.vue